// Format property name and remove date range, production source, fcst and sync portitions
// of the string
const formatPropertyName = (propertyName: string) => {
  // Taken off first because the date range is written ahead of the other two markers, so
  // cutting here already drops whatever tail follows it.
  if (propertyName.includes(".dr.")) {
    propertyName = propertyName.substring(0, propertyName.indexOf(".dr."));
  }
  // Second because it is written behind the date range, so a property carrying both is
  // already cut. On its own it still has to go, or nothing resolves the tile to a column.
  if (propertyName.includes(".pden.")) {
    propertyName = propertyName.substring(0, propertyName.indexOf(".pden."));
  }
  if (propertyName.includes("fcst")) {
    propertyName = propertyName.substring(0, propertyName.indexOf(".fcst"));
  }
  if (propertyName.includes("sync")) {
    propertyName = propertyName.substring(0, propertyName.indexOf(".sync"));
  }
  return propertyName;
};
export default formatPropertyName;
